export const DELETE_TAGS = 'delete_labels'
export const MERGE_TAGS = 'merge_labels'
export const DELETE_MESSAGE_TEMPLATES = 'delete_message_templates'
export const UPDATE_MESSAGE_TEMPLATES = 'update_message_templates'
